import Axios from 'axios';

export const uploadProductImage = async (fmData: FormData) => {
  const res = await Axios.post('/product-service/api/products/images', fmData);
  return res.data;
};
